module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "black-back"
  }, [_c('div', {
    staticClass: "score-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "score-title"
  }, [_vm._v(_vm._s(_vm.row.saiqu_name) + " " + _vm._s(_vm.row.title))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child"
  }, [_vm._v(_vm._s(_vm.row.subject.subject_name))]), _vm._v(" "), _c('div', {
    staticClass: "score-title-child",
    on: {
      "click": function($event) {
        _vm.peopleShow = true
      }
    }
  }, [_vm._v(_vm._s(_vm.row.subject.mingcheng) + "\n\n        "), _c('br'), _vm._v(" [运动员信息]\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "score-content"
  }, [_c('div', {
    staticClass: "score-content-left"
  }, [_c('div', {
    staticClass: "score-value-box"
  }, [_c('div', {
    staticClass: "score-value-text flex-between"
  }, [_c('div', {
    staticClass: "flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v("动作组合  \n\n                "), (!_vm.formData.member_name) ? _c('span', [_vm._v("对全队打分")]) : _c('span', [_vm._v("对 " + _vm._s(_vm.formData.member_name) + " ")]), _vm._v(" "), (_vm.scoreCurrent > 0) ? _c('span', [_vm._v("已打" + _vm._s(_vm.scoreCurrent) + "分")]) : _c('span', [_vm._v("没有评分或未申报考级")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-start",
    staticStyle: {
      "font-size": "18px",
      "cursor": "pointer"
    },
    on: {
      "click": _vm.onRefresh
    }
  }, [_c('van-icon', {
    attrs: {
      "name": "replay"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "2px"
    }
  }, [_vm._v("刷新")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "score-value-content flex-center"
  }, [_vm._v(_vm._s(_vm.formData.score > 0 ? _vm.formData.score : '--'))]), _vm._v(" "), (false) ? _c('div', {
    staticClass: "score-comment-box"
  }, [_c('div', {
    staticClass: "score-comment-head flex-between"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "score-comment-head-right",
    on: {
      "click": _vm.onComment
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/comment-edit.png"),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "score-comment-text"
  }, [_vm._v(_vm._s(_vm.formData.content))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "score-caipan-box score-caipan-online"
  }, [_c('div', {
    staticClass: "score-caipan-value flex-between"
  }, [_c('div', {
    staticClass: "score-caipan-left flex-start"
  }, [_c('div', {
    staticClass: "caipan-button",
    staticStyle: {
      "padding": "5px 10px 5px 0"
    },
    on: {
      "click": _vm.toLoginOutAuto
    }
  }, [_vm._v("退出")]), _vm._v(" "), _c('div', {
    staticClass: "caipan-name"
  }, [_vm._v(" " + _vm._s(_vm.row.caipan.jgroup == 1 ? 'B组裁判' + '-' + (_vm.row.caipan.index + 1) + '-' + _vm.row.caipan.name :
    'A组裁判' + '-' + (_vm.row.caipan.index + 1) + '-' + _vm.row.caipan.name) + "\n              ")])]), _vm._v(" "), _c('div', {
    staticClass: "score-caipan-right"
  }, [_vm._v("网络正常")])])])]), _vm._v(" "), _c('div', {
    staticClass: "score-content-right flex-start"
  }, [_c('div', {
    staticClass: "key-left"
  }, [_c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(1)
      }
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(2)
      }
    }
  }, [_vm._v("2")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(3)
      }
    }
  }, [_vm._v("3")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(4)
      }
    }
  }, [_vm._v("4")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(5)
      }
    }
  }, [_vm._v("5")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(6)
      }
    }
  }, [_vm._v("6")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(7)
      }
    }
  }, [_vm._v("7")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(8)
      }
    }
  }, [_vm._v("8")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey(9)
      }
    }
  }, [_vm._v("9")]), _vm._v(" "), _c('div', {
    staticClass: "key-li-full",
    on: {
      "click": function($event) {
        return _vm.onKey(0)
      }
    }
  }, [_vm._v("0")]), _vm._v(" "), _c('div', {
    staticClass: "key-li",
    on: {
      "click": function($event) {
        return _vm.onKey('.')
      }
    }
  }, [_vm._v(".")])]), _vm._v(" "), _c('div', {
    staticClass: "key-right"
  }, [_c('div', {
    staticClass: "key-delete flex-center",
    on: {
      "click": function($event) {
        return _vm.onKey('delete')
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/score-delete.png"),
      "alt": ""
    }
  })]), _vm._v(" "), (_vm.row.caipan.jgroup === _vm.row.subject.jgroup) ? _c('div', {
    staticClass: "key-button flex-center",
    staticStyle: {
      "background": "#1989FA",
      "color": "#fff"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("提交\n          ")]) : _c('div', {
    staticClass: "key-button flex-center",
    staticStyle: {
      "background": "#44D7B6",
      "color": "#fff",
      "cursor": "not-allowed"
    }
  }, [_vm._v("完成\n          ")])])])]), _vm._v(" "), (false) ? _c('div', {
    staticStyle: {
      "color": "#fff"
    }
  }, [_c('div', [_vm._v("that.formData: || " + _vm._s(_vm.formData))]), _vm._v(" "), _c('div', [_vm._v("row.caipan: || " + _vm._s(_vm.row.caipan))]), _vm._v(" "), _c('div', [_vm._v("row.subject: || " + _vm._s(_vm.row.subject))]), _vm._v(" "), _c('div', [_vm._v("scoreStatus: || " + _vm._s(_vm.scoreStatus))]), _vm._v(" "), _c('div', [_vm._v("dataAll: || " + _vm._s(_vm.dataAll))])]) : _vm._e(), _vm._v(" "), _c('van-dialog', {
    attrs: {
      "title": "添加评语"
    },
    model: {
      value: (_vm.commentShow),
      callback: function($$v) {
        _vm.commentShow = $$v
      },
      expression: "commentShow"
    }
  }, [_c('van-field', {
    attrs: {
      "clearable": "",
      "closeOnClickOverlay": true,
      "autofocus": true,
      "label": "评语",
      "placeholder": "请输入评语"
    },
    on: {
      "input": _vm.onCommentChange
    },
    model: {
      value: (_vm.formData.content),
      callback: function($$v) {
        _vm.$set(_vm.formData, "content", $$v)
      },
      expression: "formData.content"
    }
  })], 1), _vm._v(" "), _c('van-popup', {
    model: {
      value: (_vm.peopleShow),
      callback: function($$v) {
        _vm.peopleShow = $$v
      },
      expression: "peopleShow"
    }
  }, [_c('div', {
    staticClass: "people"
  }, [_c('div', {
    staticClass: "people-title"
  }, [_vm._v("对单个运动员打分")]), _vm._v(" "), _c('div', {
    staticClass: "people-content"
  }, [_c('van-tag', {
    staticStyle: {
      "margin": "10px 0 0 10px"
    },
    attrs: {
      "round": "",
      "size": "large",
      "color": "#ffe1e1",
      "text-color": "#ad0000",
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.selectMember({
          name: '',
          num: ''
        })
      }
    }
  }, [_vm._v("全体队员")]), _vm._v(" "), _vm._l((_vm.row.subject.yundongyuan), function(member, index) {
    return _c('van-tag', {
      key: index,
      staticStyle: {
        "margin": "10px 0 0 10px"
      },
      attrs: {
        "round": "",
        "size": "large",
        "color": "#ffe1e1",
        "text-color": "#ad0000",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.selectMember(member)
        }
      }
    }, [_vm._v(_vm._s(member.name))])
  })], 2)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-logo"
  }, [_c('div', {
    staticClass: "score-logo-box"
  }, [_c('img', {
    attrs: {
      "src": require("../../../assets/images/score/logo2.png"),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "score-comment-head-left flex-start"
  }, [_c('div', {
    staticClass: "score-value-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "score-value-li"
  }, [_vm._v("评语")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ca778570","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/qcxj/ExameScoreSaiForm.vue
// module id = 2603
// module chunks = 0